import gql from 'graphql-tag';

export const updateDOPEntry = gql`
  mutation updateDOPEntry($id: String, $input: UpdateDOPEntry) {
    updateDOPEntry(id: $id, input: $input) {
      id
      aorId
      aorSubSystemId
      labelId
      entry
      active
      shiftDate
      createdBy
      createdAt
      updater
      updatedAt
      deletedAt
      version
    }
  }
`;
